import {FunctionComponent} from 'react';

type CardFooterProps = {
    className?: string
}

const CardFooter: FunctionComponent<CardFooterProps> = (props) => {
    return (
        <div className={`dfb-Card-footer ${props.className}`}>
            {props.children}
        </div>
    );
};

export default CardFooter;
